// Task-level chat, same wiring CustomTask's Chat tab uses for every task type.
import { Box, Grid, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { Button } from '@roc/ui';
import { useGeneralTasksStore } from '@roc/feature-general-tasks';
import { ChatSection, FilterType, useLoanCommunicationStore } from '@roc/feature-communication';
import { ChatContainer } from '@chatscope/chat-ui-kit-react';
import { ForumOutlined } from '@material-ui/icons';

const CONVERSATIONS_START_PAGE = 1;
const CONVERSATIONS_PAGE_SIZE = 100;

export const ChatTab = observer(({ classes, taskId }: { classes: Record<string, string>; taskId?: number }) => {
  const { generalTasksStore } = useGeneralTasksStore();
  const { loanCommunicationStore } = useLoanCommunicationStore();
  const [showLoading, setShowLoading] = useState(false);

  const loadChat = () => {
    setShowLoading(true);
    loanCommunicationStore.reset();
    loanCommunicationStore.setFilter({ type: FilterType.TASK_ID, value: taskId });
    if (loanCommunicationStore.isInternal) {
      loanCommunicationStore.getAllMessageSnippets();
    }
    loanCommunicationStore.loadMyConversations(
      CONVERSATIONS_START_PAGE,
      CONVERSATIONS_PAGE_SIZE,
      (totalCount, rows) => {
        setShowLoading(false);
        if (rows[0]) {
          loanCommunicationStore.setCurrentConversation(loanCommunicationStore.conversations[rows[0].conversationSid]);
        }
      },
      () => setShowLoading(false)
    );
  };

  useEffect(() => {
    if (!taskId) return;
    generalTasksStore.checkIfTaskRoomExist(taskId, () => loadChat(), undefined, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId]);

  const createChat = () => {
    generalTasksStore.createTaskChatroom(taskId, () => loadChat(), true);
  };

  if (!taskId) {
    return <Typography className={classes.chatPlaceholder}>Chat isn't available until the task finishes loading.</Typography>;
  }

  return (
    <Grid item xs={12} style={{ padding: 16 }}>
      {generalTasksStore.taskRoomExist ? (
        <Box className={classes.chatContainer}>
          <ChatSection
            as={ChatContainer}
            communicationStore={loanCommunicationStore}
            allowJoinConversation={true}
            allowLeaveConversation={true}
            showSnippet={false}
            showEmailAddress={false}
            allowManageParticipants={true}
            allowAddInternalParticipants={true}
            allowAddParticipants={true}
            allowRemoveParticipants={true}
            onDownloadConversation={undefined}
            onUnarchiveConversation={() => undefined}
            showLoading={showLoading}
          />
        </Box>
      ) : (
        <Box className={classes.chatEmptyContainer}>
          <Button testId="startTrackRecordChat" onClick={createChat} variant="contained" className={classes.chatStartButton}>
            <Box display="flex" alignItems="center">
              <Box className={classes.chatIconCircle}>
                <ForumOutlined style={{ color: '#4285F4' }} />
              </Box>
              <Typography variant="body1" style={{ fontSize: 16, fontWeight: 'bold', marginRight: 8, color: '#FFFFFF' }}>
                Start Conversation
              </Typography>
            </Box>
          </Button>
          <Typography variant="body1" style={{ marginTop: 5, fontSize: 12, fontWeight: 'normal' }}>
            Contact us with any questions about this task.
          </Typography>
        </Box>
      )}
    </Grid>
  );
});
